export default {
  // list
  'base_currency.query.currencyCode': '币种代码',
  'base_currency.query.currencyCode.placeholder': '请输入币种代码',
  'base_currency.query.currencyName': '名称',
  'base_currency.query.currencyName.placeholder': '请输入名称',
  'base_currency.column.currencyCode': '币种代码',
  'base_currency.column.currencyName': '名称',
  'base_currency.column.currencySymbol': '符号',
  'base_currency.column.currencyUnit': '单位',
  'base_currency.column.defaultFlag': '是否本位币',
  'base_currency.column.createBy': '创建人',
  'base_currency.column.updateBy': '更新人',
  'base_currency.column.createTime': '创建时间',
  'base_currency.column.updateTime': '更新时间',
  'base_currency.column.dataSource': '数据来源',
  'base_currency.column.remark': '备注',
  'base_currency.column.status': '状态',
  // edit
  'base_currency.edit.title': '编辑币种',
  'base_currency.add.title': '新增币种',
  'base_currency.edit.success': '编辑成功',
  'base_currency.add.success': '新增成功',
  'base_currency.form.currencyCode.required': '币种代码不能为空',
  'base_currency.form.currencyName.required': '名称不能为空',
  'base_currency.form.currencySymbol.required': '符号不能为空',
  'base_currency.form.currencyUnit.required': '单位不能为空',
  'base_currency.form.defaultFlag.required': '是否本位币不能为空',
  'base_currency.form.currencyCode': '币种代码',
  'base_currency.form.currencyCode.placeholder': '请输入币种代码',
  'base_currency.form.currencyName': '名称',
  'base_currency.form.currencyName.placeholder': '请输入名称',
  'base_currency.form.currencySymbol': '符号',
  'base_currency.form.currencySymbol.placeholder': '请输入符号',
  'base_currency.form.currencyUnit': '单位',
  'base_currency.form.currencyUnit.placeholder': '请输入单位',
  'base_currency.form.defaultFlag': '是否本位币',
  'base_currency.form.defaultFlag.placeholder': '请输入是否本位币',
}
